import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import moment from "moment";
import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns"
// import Tooltip from "@mui/material/Tooltip";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { useHistory, useNavigate } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import { getRoleList } from "../../redux/actions/getRoleListAction";
import { getKycReportList } from "../../redux/actions/getKycReportListAction";
import { getTransactionTypeListDetails } from "../../redux/actions/getTransactionTypeListAction";
import { getWalletTransactionList } from "../../redux/actions/getWalletTransactionListAction";
import { getMerchantWireList } from "../../redux/actions/getMerchantWireListAction";
import { editMerchantWire } from "../../redux/actions/editMerchantWireAction";
import Autocomplete from "@mui/lab/Autocomplete";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ReactToExcel from "react-html-table-to-excel";
import Util from "../../validation/index";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";

import {
	getKycApproveRejects,
	resetGetKycApproveReject
} from "../../redux/actions/getKycApproveRejectAction";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import {
	resetGetCustomerIdAndNameList,
	getCustomerIdAndNameList
} from "../../redux/actions/getCustomerIdAndNameListAction";
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

function MerchantWireReport() {
	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);

	const [selectedToDate, setSelectedToDate] = useState(new Date());

	const [settleDate, setSettleDate] = useState();

	const [selectedDateVE, setSelectedDateVE] = useState();

	const [selectedToDateVE, setSelectedToDateVE] = useState();

	const navigate = useHistory();

	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [isLoading, setIsLoading] = useState(false);
	const [editOpen, setEditOpen] = React.useState(false);
	const [viewOpen, setViewOpen] = React.useState(false);

	const [getMerchantWireListStatus, setGetMerchantWireListStatus] =
		useState(false);
	const [getMerchantWireListArray, setGetMerchantWireListArray] = useState("");

	const [editMerchantWireStatus, setEditMerchantWireStatus] = useState(false);
	const [editMerchantWireArray, setEditMerchantWireArray] = useState("");

	const [getRoleStatus, setGetRoleStatus] = useState(false);
	const [getRoleResArray, setGetRoleResArray] = useState([]);

	const [getKycReportListStatus, setGetKycReportListStatus] = useState(false);
	const [getKycReportListArray, setGetKycReportListArray] = useState([]);

	const [getTransactionTypeListResArray, setGetTransactionTypeListResArray] =
		useState([]);

	const [getWalletTransactionListArray, setGetWalletTransactionListArray] =
		useState([]);

	const [getWalletTransactionListStatus, setGetWalletTransactionListStatus] =
		useState(false);

	const view = "view";
	const edit = "edit";

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);

	const getCustomerIdAndNameListRes = useSelector(
		({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	const [settleId, setSettleId] = useState("");
	const [processingAmount, setProcessingAmount] = useState("");
	const [chargeAmount, setChargeAmount] = useState("");
	const [netFinalAmount, setNetFinalAmount] = useState("");
	const [status, setStatus] = useState("");
	const [merchantId, setMerchantId] = useState("");

	const [user, setUser] = useState({
		// merchantId: "",
		isPaid: ""
		// settleId: "",
		// processingAmount: "",
		// chargeAmount: "",
		// netFinalAmount: "",
		// status: "",
	});

	const {
		// merchantId,
		isPaid
		// settleId,
		// processingAmount,
		// chargeAmount,
		// netFinalAmount,
		// status,
	} = user;

	const onInputChange = ({ target: { name, value } }, type) => {
		// setUser({ ...user, [e.target.name]: e.target.value });
		const obj = {
			...user
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			// obj[name] = value.trim()
			obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		}
		setUser(obj);
	};
	const handleChange = ({ target: { name, value } }) => {


		if (name === "merchantId") {
			// console.log("memberId", memberId)
			setMerchantId(value)
		}
	}
	const handleSettleDate = (date) => {
		setSettleDate(date);
	};

	const handleDateChangeVE = (date) => {
		setSelectedDateVE(date);
	};

	const handleToDateChangeVE = (date) => {
		setSelectedToDateVE(date);
	};

	const handleDateChange = (date) => {
		setSelectedDate(date);
		if(date > selectedToDate){
            setSelectedToDate(date)
        }
	};

	const handleToDateChange = (date) => {
		setSelectedToDate(date);
	};

	const getMerchantWireListRes = useSelector(
		({ getMerchantWireList }) => getMerchantWireList
	);

	const editMerchantWireRes = useSelector(
		({ editMerchantWire }) => editMerchantWire
	);

	const getRoleListRes = useSelector(({ getRoleList }) => getRoleList);

	const getKycReportListRes = useSelector(
		({ getKycReportList }) => getKycReportList
	);

	const getTransactionTypeListRes = useSelector(
		({ getTransactionTypeList }) => getTransactionTypeList
	);

	const getWalletTransactionListRes = useSelector(
		({ getWalletTransactionList }) => getWalletTransactionList
	);

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const getMerchantWireListReq = () => {
		if (!selectedDate || !selectedToDate) {
			alert("Please Select Date..!!");
			return; // Stop the execution if "From Date" is not selected
		}
		setGetMerchantWireListStatus(true);
		setIsLoading(true);
		const req = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				fdtstamp: moment(selectedDate).format("DD/MM/YYYY"),
				tdtstamp: moment(selectedToDate).format("DD/MM/YYYY"),
				status: isPaid,
				toId: merchantId.split("-")[0] || ""
			}
		};
		dispatch(getMerchantWireList(req, authToken));
	};

	const getMerchantWireListFunc = () => {
		if (getMerchantWireListStatus) {
			if (getMerchantWireListRes.data.status == "success") {
				setGetMerchantWireListArray(
					[].concat(getMerchantWireListRes.data.reportList)
				);
			}
			if (getMerchantWireListRes.data.status == "failed") {
				setGetMerchantWireListArray(getMerchantWireListRes.data);
				if (
					getMerchantWireListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getMerchantWireListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			setIsLoading(false);
		}
	};

	useEffect(() => {
		getMerchantWireListFunc();
	}, [getMerchantWireListRes.data.status]);

	const setData = (row, fs) => {
		setSettleId(row.settleId);
		setSettleDate(row.settleDate);
		setSelectedDateVE(row.firstDate);
		setSelectedToDateVE(row.lastDate);
		setProcessingAmount(row.processingAmount);
		setChargeAmount(row.chargeAmount);
		setNetFinalAmount(row.netFinalAmount);
		setStatus(row.status);
		if (fs == "view") {
			setViewOpen(true);
		}
		if (fs == "edit") {
			setEditOpen(true);
		}
	};

	const editMerchantWireReq = () => {
		setEditMerchantWireStatus(true);
		let req = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				settledDate: settleDate || "",
				status: status,
				settledId: settleId
			}
		};
		dispatch(editMerchantWire(req, authToken));
	};

	const editMerchantWireFunc = () => {
		if (editMerchantWireStatus) {
			if (editMerchantWireRes.data.status == "success") {
				setEditMerchantWireArray(editMerchantWireRes.data);
			}
			if (editMerchantWireRes.data.status == "failed") {
				setEditMerchantWireArray(editMerchantWireRes.data);
				if (
					editMerchantWireRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					editMerchantWireRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		editMerchantWireFunc();
	}, [editMerchantWireRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setEditOpen(false);
		setViewOpen(false);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getCustomerIdAndNameReq = {
				loginDetails: {
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				},
				actionCustomerMasterRequestVO: {
					customerNameOrId: ""
				}
			};

			dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
		}
	}, [regenerateTokenRes.data.status]);

	const filterOptions = (options, { inputValue }) => {
		//console.log(options, inputValue, "optionsss")
		if (inputValue.length < 3) {
			return [];
		}

		const filterOptionsList = options.filter(
			(option) =>
				option.includes(inputValue) ||
				""
		);

		return filterOptionsList.slice(0, 20);
	}

	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<FormControl fullWidth>
								 <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="From Date"
										format="MM/dd/yyyy"
										value={selectedDate}
										onChange={handleDateChange}
									/>
								  </LocalizationProvider>
							</FormControl>
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<FormControl fullWidth>
								 <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="To Date"
										format="MM/dd/yyyy"
										value={selectedToDate}
										onChange={handleToDateChange}
										minDate={selectedDate}
									/>
								  </LocalizationProvider>
							</FormControl>
						</Grid>
						{/* <Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								size="small"
								color="primary"
								type="text"
								label="Merchant ID"
								fullWidth={true}
								name="merchantId"
								value={merchantId}
								variant="standard"
								// onChange={onInputChange}
								onChange={(e) => onInputChange(e, "number")}
							></TextField>
						</Grid> */}
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<Autocomplete
								id="combo-box-demo"
								options={[].concat(
									getCustomerIdAndNameListRes.data.currencyList || [""]
								)}
								getOptionLabel={(option) => option}
								filterOptions={filterOptions}
								value={merchantId}
								onChange={handleChange}
								onInputChange={(event, newInputValue) => {
									setMerchantId(newInputValue);
								}}
								renderInput={(params) => (
									<TextField
										autoFocus
										margin="dense"
										id="name"
										label="Merchant ID"
										style={{ marginTop: "3px" }}
										// required
										type="tel"
										fullWidth
										{...params}
										// value={merchantID}
										name="merchantId"
										// onChange={(e) => onInputChange(e, "number")}

										variant="standard"
										sx={{
											"& .MuiInput-underline:before": {
											  borderBottomColor: "gray", // White color for the underline before focus
											},
											"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
											  borderBottomColor: "gray", // White color on hover
											},
											"& .MuiInput-underline:after": {
											  borderBottomColor: "gray", // White color after focus
											},
										  }}
									/>
								)}
							/>
						</Grid>



						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								style={{ marginTop: "0rem" }}
								select
								autoFocus
								margin="dense"
								id="name"
								label="Is Paid"
								type="name"
								fullWidth
								name="isPaid"
								variant="standard"

								// value={verificationStatus || ""}
								defaultValue={"All" || isPaid}
								onChange={(e) => onInputChange(e)}
								sx={{
									"& .MuiInput-underline:before": {
									  borderBottomColor: "gray", // White color for the underline before focus
									},
									"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
									  borderBottomColor: "gray", // White color on hover
									},
									"& .MuiInput-underline:after": {
									  borderBottomColor: "gray", // White color after focus
									},
								  }}
							>
								<MenuItem value="All" selected="All">
									All
								</MenuItem>
								<MenuItem value="paid">Paid</MenuItem>
								<MenuItem value="unpaid">Unpaid</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							{/* <Button
                                style={{
                                    backgroundColor: "#00b9f5",
                                    color: "white",
                                    marginTop: "9px",
                                }}
                                endIcon={<AiOutlineSearch />}
                                variant="contained"
                                onClick={getMerchantWireListReq}
                            >
                                Search
                            </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getMerchantWireListReq}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getMerchantWireListArray.length == undefined ||
				  !getMerchantWireListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Summary Data
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
									// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<div>
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography
										variant="body1"
										style={{ fontWeight: "700" }}
										className="themeText"
									>
										Report Table
									</Typography>
								</Grid>
								<TableContainer component={Paper} className="text-nowrap my-3">
									<Table className={classes.table}>
										<TableHead>
											<TableRow className="tableHeaderColor">
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Merchant ID{" "}
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Cycle ID
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Settled Date
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													First Date
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Last Date
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Processing Amount
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Charge Amount
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Net Final Amount
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Unpaid Amount
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Currency
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Status
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Report File
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Transaction File
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Action
												</TableCell>
											</TableRow>
										</TableHead>

										<TableBody>
											{getMerchantWireListArray &&
												[]
													.concat(getMerchantWireListArray)
													.slice(
														page * rowsPerPage,
														page * rowsPerPage + rowsPerPage
													)
													.map((row, index) => (
														<TableRow key={index}>
															<TableCell align="center">
																{row.memberId}
															</TableCell>
															<TableCell align="center">
																{row.settlementCycleNo}
															</TableCell>
															<TableCell align="center">
																{row.settleDate}
															</TableCell>
															<TableCell align="center">
																{row.firstDate}
															</TableCell>
															<TableCell align="center">
																{row.lastDate}
															</TableCell>

															<TableCell align="center">
																{row.processingAmount}
															</TableCell>
															<TableCell align="center">
																{row.chargeAmount}
															</TableCell>

															<TableCell align="center">
																{row.netFinalAmount}
															</TableCell>
															<TableCell align="center">
																{row.unpaidAmount}
															</TableCell>
															<TableCell align="center">
																{row.currency}
															</TableCell>
															<TableCell align="center">{row.status}</TableCell>
															<TableCell align="center"></TableCell>
															<TableCell align="center"></TableCell>
															<TableCell align="center">
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	onClick={() => setData(row, "view")}
																>
																	{
																		<VisibilityIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	onClick={() => setData(row, "edit")}
																>
																	{
																		<EditIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
															</TableCell>
														</TableRow>
													))}
										</TableBody>
									</Table>
									<TablePagination
										rowsPerPageOptions={[5, 10, 25]}
										component="div"
										count={[].concat(getMerchantWireListArray).length}
										rowsPerPage={rowsPerPage}
										page={page}
										onChangePage={handleChangePage}
										onChangeRowsPerPage={handleChangeRowsPerPage}
									/>
								</TableContainer>
							</Grid>
						</Card>
					</div>
				)}
			</Layout>
			<div>
				<Dialog open={editOpen} onClose={handleClose}>
					<DialogTitle>Edit Integration</DialogTitle>
					<DialogContent>
						<TextField
							required
							disabled
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Settled ID"
							fullWidth={true}
							name="settleId"
							value={settleId || ""}
						></TextField>

						<TextField
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Settled Date"
							fullWidth={true}
							name="settleDate"
							value={settleDate || ""}
						></TextField>

						<TextField
							required
							disabled
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Start Date"
							fullWidth={true}
							name="selectedDateVE"
							value={selectedDateVE || ""}
						></TextField>

						<TextField
							required
							disabled
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="End Date"
							fullWidth={true}
							name="selectedToDateVE"
							value={selectedToDateVE || ""}
						></TextField>

						<TextField
							required
							disabled
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Processing Amount"
							fullWidth={true}
							name="processingAmount"
							value={processingAmount || ""}
						></TextField>

						<TextField
							required
							disabled
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Charge Amount"
							fullWidth={true}
							name="chargeAmount"
							value={chargeAmount || ""}
						></TextField>

						<TextField
							required
							disabled
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Net Final Amount"
							fullWidth={true}
							name="netFinalAmount"
							value={netFinalAmount || ""}
						></TextField>

						<TextField
							required
							select
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Status"
							fullWidth={true}
							name="status"
							defaultValue={status || ""}
						>
							<MenuItem value="paid">Paid</MenuItem>
							<MenuItem value="unpaid">Unpaid</MenuItem>
						</TextField>
					</DialogContent>
					<DialogActions style={{ padding: "14px" }}>
						<Button
							style={{
								backgroundColor: "#fff",
								color: "#000"
							}}
							variant="contained"
							onClick={handleClose}
						>
							Cancel
						</Button>
						{/* <Button
							style={{
								backgroundColor: "#00b9f5",
								color: "white"
							}}
							variant="contained"
							onClick={editMerchantWireReq}
						>
							Edit
						</Button> */}
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={editMerchantWireReq}
						>
							Edit
						</CustomButton>
					</DialogActions>
				</Dialog>
			</div>

			<div>
				<Dialog open={viewOpen} onClose={handleClose}>
					<DialogTitle>View Merchant Wire Report</DialogTitle>
					<DialogContent>
						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Settled ID"
							fullWidth={true}
							name="settleId"
							value={settleId || ""}
						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Settled Date"
							fullWidth={true}
							name="settleDate"
							value={settleDate || ""}
						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Start Date"
							fullWidth={true}
							name="selectedDateVE"
							value={selectedDateVE || ""}
						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="End Date"
							fullWidth={true}
							name="selectedToDateVE"
							value={selectedToDateVE || ""}
						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Processing Amount"
							fullWidth={true}
							name="processingAmount"
							value={processingAmount || ""}
						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Charge Amount"
							fullWidth={true}
							name="chargeAmount"
							value={chargeAmount || ""}
						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Net Final Amount"
							fullWidth={true}
							name="netFinalAmount"
							value={netFinalAmount || ""}
						></TextField>

						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Status"
							fullWidth={true}
							name="status"
							defaultValue={status || ""}
						></TextField>
					</DialogContent>
					<DialogActions style={{ padding: "14px" }}>
						{/* <Button
							style={{
								backgroundColor: "#00b9f5",
								color: "white"
							}}
							variant="contained"
							onClick={handleClose}
						>
							Close
						</Button> */}
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={handleClose}
						>
							Close
						</CustomButton>
					</DialogActions>
				</Dialog>
			</div>
		</>
	);
}

export default MerchantWireReport;
